// extracted by mini-css-extract-plugin
export default {"BoxMessageError":"TeamManagement_BoxMessageError__kNGfD"};